<p>new-invoice works!</p>
